import styled from 'styled-components';

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 8px 0 8px 16px;
`;
